import React, {Component} from 'react';
import {DatePicker, Form, Input} from "antd";
import moment from "moment";

class DraftReplyTime extends Component {
    constructor(props) {
        super(props);
        this.state={
            replyTime:props.itemValue||null,
        }
    }
    componentDidMount() {
    }


    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex",alignItems:"center",width:"50%"}}  labelCol={{ span: 5 }} wrapperCol={{ span: 20 }}>
                <DatePicker style={{width:"280px"}}
                            className={'DraftReplyTime'}
                            value={this.state.replyTime?moment(this.state.replyTime):null}
                            onChange={endDate=>{
                                let replyTime = endDate?endDate.valueOf():null;
                                this.setState({replyTime
                                },()=>{
                                    this.props.callBack&&this.props.callBack(replyTime)
                                });
                            }}
                            placeholder={this.props.placeholder}
                            disabledDate={(current)=>{
                                return current && current < moment().subtract(1, 'days').endOf('day')
                            }}
                            showTime
                            format="YYYY-MM-DD HH:mm" />

                <style>{`.DraftReplyTime  .ant-input{background: rgba(0, 80, 179, 0.04)}`}</style>
            </Form.Item>




        );
    }
}



export default DraftReplyTime;